import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import {
    AssaysEvaluationsGridSidePanelState,
    initialAssaysEvaluationsGridSidePanelState
} from '@/modules/diagnosisModule/components/assays-evaluations-grid-sidepanel/assays-evaluations-grid-sidepanel.models'
import {
    AssayEvaluationAssayResultCreateRequest,
    AssayEvaluationAssayResultUpdateRequest,
    AssaysEvaluationAssayGridResponse
} from '@/modules/diagnosisModule/components/assays-evaluations-grid/assays-evaluations-grid.models'

@Component({
    components: {}
})
export default class AssaysEvaluationsGridSidePanel extends Vue {
    @Prop({ default: null }) readonly subportion!: AssaysEvaluationAssayGridResponse
    @Watch('subportion', { deep: true })
    onSubportionChanged(): void {
        if (this.subportion) {
            this.state.id = this.subportion.result?.id
            this.state.comment = this.subportion.result?.comment
            this.state.originalComment = this.subportion.result?.comment
            this.state.customData = this.subportion.result?.customData
        }
    }
    @Emit('subportionCommentUpdate')
    private emitOnSubportionCommentUpdate(): AssayEvaluationAssayResultUpdateRequest {
        return {
            portionId: this.subportion.portionId,
            subportionId: this.subportion.subportionId,
            id: this.subportion.result?.id,
            updateRequests: {
                subportionAccredited: this.subportion.subportionAccredited,
                subportionVisibleInReport: this.subportion.subportionVisibleInReport,
                customData: this.subportion.result?.customData,
                percentage: this.subportion.result?.percentage,
                qualitativeResultId: this.subportion.result?.possibleAssayResult?.id,
                comment: this.state.comment
            }
        }
    }
    @Emit('subportionCommentCreate')
    private emitOnSubportionCommentCreate(): AssayEvaluationAssayResultCreateRequest {
        return {
            portionId: this.subportion.portionId,
            subportionId: this.subportion.subportionId,
            requests: {
                subportionAccredited: this.subportion.subportionAccredited,
                subportionVisibleInReport: this.subportion.subportionVisibleInReport,
                customData: this.subportion.result?.customData,
                percentage: this.subportion.result?.percentage,
                comment: this.state.comment
            }
        }
    }
    @Emit('closeSidePanel')
    private emitOnCloseSidePanel(): boolean {
        return true
    }

    state: AssaysEvaluationsGridSidePanelState
    constructor() {
        super()
        this.state = initialAssaysEvaluationsGridSidePanelState()
    }

    get subportionLabel(): string | null {
        return this.subportion?.label
    }

    get emptyCustomData(): boolean {
        return !!this.state.customData?.length
    }

    onCloseAdditionalSidepanelClick(): void {
        this.emitOnCloseSidePanel()
    }
    onAddCommentClick(): void {
        this.state.isCommentBoxOpen = true
    }

    onCancelCommentClick(): void {
        this.state.isCommentBoxOpen = false
        this.state.comment = this.state.originalComment
    }

    onUpdateCommentClick(): void {
        this.state.isCommentBoxOpen = true
    }

    onApplyCommentClick(): void {
        this.state.isCommentBoxOpen = false
        if (this.subportion.result) {
            this.emitOnSubportionCommentUpdate()
        } else {
            this.emitOnSubportionCommentCreate()
        }
    }
}
